import { ListItem } from '@wartek-id/list'
import { useToast } from '@wartek-id/toast'

import {
  useAPIPelaksanaanReset,
  useAPIResetPerencanaanAndPelaksanaan,
} from 'api/kinerja/useAPIKinerja'
import useResetToggle from 'app/KinerjaPage/hooks/useResetToggle'
import { useAuth } from 'utils/auth'
import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'

export default function ResetButtons() {
  const { enabled: resetEnabled, isLoading: isLoadingToggle } = useResetToggle()
  const { session } = useAuth()

  const errorPenilaianFound =
    'predicate data has already created, ask headmaster to remove the predicate first'

  const { mutateAsync: resetPerencanaanAndPelaksanaanGuru } =
    useAPIResetPerencanaanAndPelaksanaan()
  const { mutateAsync: resetCurrentSKPPelaksanaanGuru } =
    useAPIPelaksanaanReset(session?.user?.ptkId)
  const toast = useToast()

  const onResetPerencanaanClick = async () => {
    if (confirm('Apakah Anda yakin ingin mereset data SKP Perencanaan?')) {
      try {
        await resetPerencanaanAndPelaksanaanGuru({})

        // Refresh the page
        window.location.href = PENGELOLAAN_KINERJA_GURU_PATH
      } catch (_err) {
        toast({
          message: 'Gagal mereset data SKP Perencanaan',
        })
      }
    }
  }

  const onResetPelaksanaanClick = () => {
    if (confirm('Apakah Anda yakin ingin mereset data SKP Pelaksanaan?')) {
      resetCurrentSKPPelaksanaanGuru(
        { targetState: '' },
        {
          onSuccess: () => {
            // force refresh the page if the current page is the SKP homepage
            // (i.e. /pengelolaan-kinerja)
            // otherwise, go to the homepage
            window.location.href = PENGELOLAAN_KINERJA_GURU_PATH
          },
          onError: (error) => {
            let errorMessage = 'Gagal mereset data SKP Pelaksanaan'

            if (
              error?.originalError?.response?.data?.error?.message ===
              errorPenilaianFound
            ) {
              errorMessage =
                'SKP sudah pernah dinilai, mohon beritahu Kepala Sekolah untuk reset penilaian dulu.'
            }
            toast({
              message: errorMessage,
            })
          },
        }
      )
    }
  }

  return !!resetEnabled && !isLoadingToggle ? (
    <>
      <ListItem onClick={onResetPerencanaanClick} className="cursor-pointer">
        Reset Data Perencanaan
      </ListItem>
      <ListItem onClick={onResetPelaksanaanClick} className="cursor-pointer">
        Reset Data Pelaksanaan
      </ListItem>
    </>
  ) : (
    // add dummy fragment in order to avoid error
    // when the menu bar is opened and the env variable above is false
    // (i.e. in production)
    <></>
  )
}
